import {
  formatUnixDate,
  FILENAME_DATE_FORMAT,
} from 'shared/helpers/dateFormat';

export const downloadCsvFile = (fileName, content) => {
  const contentType = 'data:text/csv;charset=utf-8;';
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  link.click();
  return link;
};

export const downloadBlob = (fileName, blob) => {
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  link.click();
  // deferred so the browser has a chance to start the download before the url is released
  setTimeout(() => URL.revokeObjectURL(url), 0);
  return link;
};

export const generateFileName = ({ type, to, businessHours = false }) => {
  let name = `${type}-report-${formatUnixDate(to, FILENAME_DATE_FORMAT)}`;
  if (businessHours) {
    name = `${name}-business-hours`;
  }
  return `${name}.csv`;
};
